export const SOCIAL_SOURCES = [
  "twitter",
  "telegram",
  "instagram",
  "facebook",
  "reddit",
  "youtube",
  "weibo",
  "vk",
  "toutiao",
];
